import React from 'react'

export function Formheader({
  children,
  className = '',
  margin = 'my-4'
}) {
  return (
    <div className={`${margin}`}>
      <h3 className={`text-md font-bold ${className}`}>{children}</h3>
    </div>
  )
}
